export default __webpack_public_path__ + "static/media/logo.aa1c4fac.svg";